var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.35,
    height: 20.711,
    viewBox: "0 0 22.35 20.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cbcbd1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.121,19.09V17.44h3.241v1.65a1.62,1.62,0,0,1-3.241,0Zm-14.041,0V17.44H4.32v1.65a1.62,1.62,0,0,1-3.24,0ZM1,17.439a1,1,0,0,1-1-1V8.629a1,1,0,0,1,1-1H2.161V3a3,3,0,0,1,3-3h9.122a3,3,0,0,1,3,3V7.629h1.16a1,1,0,0,1,1,1v7.81a1,1,0,0,1-1,1Zm11.961-5.45a2.161,2.161,0,1,0,2.16-2.18A2.173,2.173,0,0,0,12.961,11.989Zm-10.8,0a2.161,2.161,0,1,0,2.16-2.18A2.173,2.173,0,0,0,2.16,11.989Zm2.161-8.81V7.629h10.8V3.179a1,1,0,0,0-1-1h-8.8A1,1,0,0,0,4.321,3.179Z",
    transform: "translate(1.455 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.909,
    height: 1.474,
    rx: 0.737,
    transform: "translate(19.441 7.921)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.909,
    height: 1.474,
    rx: 0.737,
    transform: "translate(0 7.921)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.ff83e2566d43b4d47e45686406c1b9fa.svg";
export { ForwardRef as ReactComponent };